// Điển Tịch `destiny.codex` (UI_SPEC §18.3), bản tối giản của M1: số mục đã ghi (caption) và danh
// sách mục; chạm một mục mở cửa sổ đọc. Nhân Quả Bộ, Tàn Niệm, Vạn Yêu Lục đến ở giai đoạn sau.
import type { JSX } from 'preact';
import { t } from '@i18n/t';
import { codexEntries } from '@state/modules/story';
import { openWindow } from '@state/modules/ui';

export function CodexScreen(): JSX.Element {
  const ids = codexEntries.value;
  return (
    <>
      <div class="ht-caption" data-id="caption">
        <b>{t('ui.screen.destiny.codex')}</b>
        <span data-id="codex-count">{t('ui.codex.count', { n: ids.length })}</span>
      </div>
      <div class="codex-list" data-id="codex-list">
        {ids.length === 0 && <p class="codex-empty">{t('ui.codex.empty')}</p>}
        {ids.map((id) => (
          <button
            type="button"
            class="codex-row"
            key={id}
            data-id={`codex-${id}`}
            onClick={() => openWindow({ kind: 'codex', entryId: id })}
          >
            {t(`${id}.title`)}
          </button>
        ))}
      </div>
    </>
  );
}

export function CodexWindow({ entryId }: { entryId: string }): JSX.Element {
  return (
    <div class="ht-block codex-body" data-id="codex-body">
      {t(`${entryId}.body`)}
    </div>
  );
}
